<template>
  <div class="page-title">
    <div class="row">
      <div class="col-xl-7">
        <div>
          <ol class="breadcrumb text-uppercase font-size-xs p-0">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);">Dashboard</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ pasien.nama || null }}</li>
          </ol>
          <h5 class="display-4 mt-1 mb-2 font-weight-bold">{{ pasien.nama || null }}</h5>
          <!-- <template v-if="pasien.nomor_rekam_medis">
            <p
              style="font-weight:bold;color:#3f41b1;"
              class="mb-0"
            >NO RM. : {{pasien.nomor_rekam_medis}} / {{(pasien.jenis_kelamin==1)?'Laki-laki':'Perempuan'}} / {{age}} </p>
          </template> -->
        </div>
        <!-- <p style="font-weight:bold;color:#3f41b1;"
            class="mb-0"
          >Hari ini : {{tanggal}}</p> -->
      </div>
      <div class="col-xl-5 d-flex align-items-center justify-content-start mt-4 mt-xl-0 justify-content-xl-end">
        <div class="mx-auto mx-xl-0">
          <b-button v-if="trx.kategori_id == '2'" class="mr-4 custom-blue" variant="primary" @click="icareHandler">I-CARE JKN</b-button>
          <b-button v-tooltip="'Riwayat'" variant="primary" @click="goToRiwayat">Lihat Riwayat</b-button>
        </div>
      </div>
      <b-row class="box-info">
        <b-col md="6">
          <b-row>
            <b-col md="5">No. Rekam Medis</b-col>
            <b-col md="7">: {{ nomor_rekam_medis || "" }}</b-col>
            <b-col md="5">Jenis Kelamin</b-col>
            <b-col md="7">: {{ jenis_kelamin }}</b-col>
            <b-col md="5">Tanggal lahir (usia)</b-col>
            <b-col md="7">: {{ tanggal_lahir }}</b-col>
            <b-col md="5">Agama</b-col>
            <b-col md="7">: {{ pasien.agama || '' }}</b-col>
            <b-col md="5">Alamat Pasien</b-col>
            <b-col md="7">: {{ address }}</b-col>
          </b-row>
        </b-col>
        <b-col md="6">
          <b-row>
            <b-col md="5">Jenis identitas</b-col>
            <b-col md="7">: {{ pasien.jenis_identitas || '' }}</b-col>
            <b-col md="5">Nomor identitas</b-col>
            <b-col md="7">: {{ pasien.nik || '' }}</b-col>
            <b-col md="5">Tanggal Konsultasi Terakhir</b-col>
            <b-col md="7">: {{ waktu_konsultasi_terakhir }}</b-col>
            <b-col md="5">Tanggal Konsultasi Saat Ini</b-col>
            <b-col md="7">: {{ waktu_konsultasi }}</b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faStar,
  faFileCode,
  faExpandArrowsAlt,
  faBuilding
} from "@fortawesome/free-solid-svg-icons";
import { mapGetters } from "vuex";
import moment from 'moment';
import axios from "axios";
import startCase from "lodash/startCase";
moment.locale('id');

library.add(faStar, faFileCode, faExpandArrowsAlt, faBuilding);

export default {
  data: () => {
    return {
      dataLoadSuccessfull: false
    }
  },
  props: {
    icon: String,
    heading: String,
    subheading: String
  },
  computed: {
    ...mapGetters(["pasien", "getKlinikId", "trx"]),
    nomor_rekam_medis: function () {
      if (this.pasien['nomor_rekam_medis']) {
        return this.pasien['nomor_rekam_medis'] + (this.pasien['nomor_rekam_medis_manual'] ? `/ ${this.pasien['nomor_rekam_medis_manual']}` : '');
      }
      return null
    },
    tanggal_lahir: function () {
      return this.pasien.tanggal_lahir ? `${this.pasien.tanggal_lahir} (${this.pasien['age_year']} tahun ${this.pasien['age_month']} bulan ${this.pasien['age_day']} hari)` : '';
    },
    waktu_konsultasi: function () {
      return this.pasien['waktu_konsultasi'] ? moment(this.pasien['waktu_konsultasi']).format('dddd, Do MMMM YYYY') : '';
    },
    waktu_konsultasi_terakhir: function () {
      return this.pasien['waktu_konsultasi_terakhir'] ? moment(this.pasien['waktu_konsultasi_terakhir']).format('dddd, Do MMMM YYYY') : '';
    },
    address: function () {
      let address = this.pasien['alamat_rumah'];
      if (this.pasien && this.pasien['kota']) address = `${address}, ${this.pasien.kota['nama']}`;
      if (this.pasien && this.pasien['provinsi']) address = `${address}, ${this.pasien.provinsi['provinsi_nama']}`;
      return address;
    },
    jenis_kelamin: function () {
      const gender = ['Perempuan', 'Laki-laki', 'Tidak diketahui', 'Tidak dapat ditentukan', 'Tidak mengisi'];
      return this.pasien && [0, 1, 2, 3, 4].includes(this.pasien['jenis_kelamin']) ? gender[this.pasien['jenis_kelamin']] : '';
    },
  },
  methods: {
    async icareHandler(){
      try {
        const response = await axios.post(
          `${this.url_api}/bpjs/icare/fktp?klinik_id=${this.getKlinikId}`,
          {
            param: this.pasien['bpjs_noka']
          }
        );

        if(response.data.metaData.code == 200 && response.data.metaData.message == "Sukses"){
          window.open(response.data.response.url, '_blank');
        } else {
          this.$swal({
            text: response.data.metaData.message,
            type: "error",
            showCancelButton: false,
          });
        }
      } catch (error) {
        // console.error(error);
      }
    },
    async goToRiwayat() {
      let withParentQS = '';
      if (localStorage.getItem('with_parent') == 1) {
        withParentQS = '&with_parent=1';
      }
      let res = await axios.get(`${this.url_api}/pasien/${this.pasien_id}?klinik_id=${this.getKlinikId}&id=${this.$router.currentRoute.params.pasien_id}${withParentQS}`);
      if (res.data.status == false || res.data.data_rm == false) {
        this.$swal({
          type: "error",
          title: startCase("Gagal"),
          text: startCase(`Pasien ${res.data.data.nama} belum memiliki rekam medis!`)
        })
      } else {

        localStorage.setItem('rekam_medis', window.location.pathname)
        localStorage.setItem('with_parent', 1)
        let routeData = this.$router.resolve({
          name: "klinik-riwayat-rekam-medis",
          params: {
            pasien_id: this.$router.currentRoute.params.pasien_id
          }
        });
        window.open(routeData.href, '_blank');
      }
    },
  }
};
</script>

<style>
.box-info {
  padding: 1.5rem 1rem;
  border-radius: .7rem;
  line-height: 1.75rem;
  background-color: #dcebfe;
  font-size: 0.75rem;
}

.custom-blue {
	color: #fff;
	background-color: #1384c8;
	border-color: #1384c8;
}

.custom-blue:hover,
.custom-blue:active {
	color: #fff;
	background-color: #1070ad !important;
	border-color: #1070ad !important;
}
</style>